import React from 'react';
import PropTypes from 'prop-types';
import { ALL_ONLINE_ORDERING_FULFILLMENT_METHODS } from 'bento-ordering/cart/constants/fulfillmentOptions';

import NoAsapSnackbar from 'bento-ordering/base/components/NoAsapSnackbar';

const NO_THROTTLE_ASAP_HEADING = 'We are especially busy at this time';
const NoAsapForThrottlesSnackbar = ({
  open,
  onClose,
  today,
  cartWorkingCopy,
  availableFulfillmentOptions,
  deliveryDate,
  deliveryTime,
  pickupDate,
  pickupTime
}) => {
  return (
    <NoAsapSnackbar
      open={open}
      onClose={onClose}
      pickupTime={pickupTime}
      pickupDate={pickupDate}
      deliveryDate={deliveryDate}
      deliveryTime={deliveryTime}
      snackbarHeadingOverride={NO_THROTTLE_ASAP_HEADING}
      isAsapAvailableForPickup={false}
      isAsapAvailableForDelivery={false}
      today={today}
      cartWorkingCopy={cartWorkingCopy}
      availableFulfillmentOptions={availableFulfillmentOptions}
    />
  );
};

NoAsapForThrottlesSnackbar.defaultProps = {
  open: false,
  onClose: () => {}
};

NoAsapForThrottlesSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  today: PropTypes.string,
  cartWorkingCopy: PropTypes.object,
  availableFulfillmentOptions: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
  ),
  deliveryDate: PropTypes.string,
  deliveryTime: PropTypes.string,
  pickupDate: PropTypes.string,
  pickupTime: PropTypes.string
};

export default NoAsapForThrottlesSnackbar;
